import React, { Component } from 'react';
import { getStoreSubscribers, removeStoreSubscriber, getStoresList, sendEmailToStoreSubscribers } from '../../modules/Api';
import ReactTable from 'react-table';
import moment from 'moment-jalaali';
import { Select, Button, notification } from 'antd';
import Email from '../../components/Email';
import history from '../../modules/History';
import ACL from '../../components/ACL';

const Option = Select.Option;

class Subscribers extends Component {
    constructor() {
        super();
        this.state = {
            items: [],
            stores: [],
            brandId: '',
            visibleModal: false,
            email: '',
            status: 1,
            emailState: Email.initialState(),
            filteredStoreKeyword: '',
            pageSize: 15,
            count: 0,
            last_page: 1,
        }
    }

    componentDidMount() {
        getStoresList(``, res => {this.setState({stores: res})});
    }

    fetchData = (query=``) => {
        getStoreSubscribers(query, (data) => {this.setState({
            items: data.data,
            count: data.total,
            last_page: data.last_page,
            pageSize: data.per_page
        })});
    }

    onChange(state) {
        this.setState({pageSize: state.pageSize});

        let sort = "";

        if(state.sorted && state.sorted.length > 0) {
            sort = JSON.stringify({
                item: state.sorted[0].id,
                desc: state.sorted[0].desc
            });
        }

        if(state.filtered === undefined) {
            const query  = `page=${state.page  + 1}&per_page=${state.pageSize}&filter[brand_id]=${this.state.brandId}&sort=${sort}`;
            this.fetchData(query);
        }else{
            const email  = state.filtered.find(f => f.id === 'email') ? state.filtered.find(f => f.id === 'email').value : '';
            const status = state.filtered.find(f => f.id === 'status') ? state.filtered.find(f => f.id === 'status').value : '';
            const query  = `page=${state.page  + 1}&per_page=${state.pageSize}&filter[brand_id]=${this.state.brandId}&filter[email]=${email}&filter[status]=${status}&sort=${sort}`;
            this.fetchData(query);
        }

    }

    setStore(id) {
        this.setState({brandId: id}, () => {
            this.onChange({page: 0, pageSize: 15});
        })
    }

    removeItem(id) {
        const warningMessage = `آیا از حذف اطمینان کامل دارید ؟  !`;
        if (window.confirm(warningMessage)) {
            removeStoreSubscriber(id, () => {
                this.fetchData();
                notification.open({
                    message: `آیتم با موفقیت حذف شد!`
                })
            })
        }
    }

    openModal() {
        this.setState({visibleModal: true});
    }

    commitModalChanges(data) {
        const payload = {
            email: data,
            filter: {
                brand_id: this.state.brandId
            }
        };
        notification.open({message: `اطلاعات در حال ارسال است . لطفا منتظر بمانید ...`})
        sendEmailToStoreSubscribers(payload, (data) => {
            notification.open({message: data.message});
        });
        this.closeModal();
    }

    closeModal() {
        this.setState({visibleModal: false});
    }

    render() {

        const stores = this.state.stores.filter(s => s.name.startsWith(this.state.filteredStoreKeyword));
        const columns = [
            {
                Header: 'آیدی',
                accessor: 'id',
            },
            {
                Header: 'ایمیل',
                accessor: 'email',
                filterable: true,
                Cell: (row) => (<span style={{width: '100px'}} title={row.original.email}> {row.original.email} </span>)
            },
            // deprecated
            // {
            //     Header: 'فروشگاه',
            //     accessor: 'brand_id',
            //     Cell: (row) => (<span title={row.original.store_name}> {row.original.store_name} </span>)
            // },
            {
                Header: 'خبرنامه‌ها',
                accessor: 'count.newsletters',
                Cell: (row) => (<span title={row.original.count.newsletters}> {row.original.count.newsletters} </span>)
            },
            {
                Header: 'ارسال شده',
                accessor: 'count.sent',
                Cell: (row) => (<span title={row.original.count.sent}> {row.original.count.sent} </span>)
            },
            {
                Header: 'مشاهده',
                accessor: 'count.viewed',
                Cell: (row) => (<span title={row.original.count.viewed}> {row.original.count.viewed} </span>)
            },
            {
                Header: 'کلیک',
                accessor: 'count.clicked',
                Cell: (row) => (<span title={row.original.count.clicked}> {row.original.count.clicked} </span>)
            },
            {
                Header: 'تاریخ ایجاد',
                accessor: 'created_at',
                Cell: (row) => (<span>{
                    row.original.created_at
                    ? moment(row.original.created_at).format('jYYYY/jMM/jDD')
                    : null
                }</span>)
            },
            {
                Header: 'وضعیت',
                accessor: 'status',
                filterable: true,
                Cell: (row) => (
                <div title={row.original.status === 2 ? 'غیر‌فعال' : 'فعال'} style={{width:100+'%', textAlign:'center'}}>
                    <span style={{padding:0 + 2+'rem',backgroundColor: row.original.status === 2 ? '#f5222d' : '#52c41a',}}>
                        {row.original.status === 2 ? 'غیر‌فعال' : 'فعال'}
                    </span>
                </div>
                ),
            },
            {
                Header: 'عملیات',
                accessor: 'delete',
                Cell: (row) => (
                    <React.Fragment>
                        <ACL component="span" has_permission="subscribers_management|subscribers_delete"><span onClick={() => {this.removeItem(row.original.id)}} style={{color: 'tomato', cursor: 'pointer', marginTop: '20%'}} >X </span></ACL>
                        <ACL component="span" has_permission="subscribers_management|subscribers_history"><span onClick={() => history.item.push(`/history/subscriber/${row.original.id}`)} className="link">H</span></ACL>
                    </React.Fragment>
                )
            },
        ];
        let table;
        table = (
            <ReactTable
            data={this.state.items}
            columns={columns}
            onFetchData={state => this.onChange(state)}
            manual
            defaultPageSize={this.state.pageSize}
            pages={this.state.last_page}/>
        );
    return(
            <div style={{textAlign: 'center'}}>
                <b>تعداد کل : {this.state.count}</b>
                <div className="btn-container">
                    <Select filterOption={false} mode="combobox" placeholder="انتخاب فروشگاه" style={{width: '200px'}} showSearch={true} onChange={k => {this.setState({filteredStoreKeyword: k})}} onSelect={this.setStore.bind(this)}>
                        {stores.map(s => <Option value={s.id.toString()} key={`ss__${s.id}`}>{s.name}</Option>)}
                    </Select>
                    <ACL component="span" has_permission="subscribers_management|subscribers_add"><Button
                        type="primary"
                        htmlType="button"
                        onClick={this.openModal.bind(this)}>
                        ارسال ایمیل
                    </Button>
                    </ACL>
                    <ACL component="span" has_permission="subscribers_management|subscribers_history"><Button type="secondary" onClick={() => history.item.push(`/history/subscriber`)}>تاریخچه تغییرات</Button></ACL>
                </div>
                <br />
                وضعیت
                2:‌ غیر‌فعال
                1: فعال
                <br />
                {table}
                <Email
                    visible={this.state.visibleModal}
                    open={this.openModal.bind(this)}
                    close={this.closeModal.bind(this)}
                    commit={this.commitModalChanges.bind(this)}/>

            </div>
        );
    }
}

export default Subscribers;


// WEBPACK FOOTER //
// ./src/containers/Subscribers/index.js